import { MODULE_ACHAT, SOUS_TYPE_NORMAL } from '@/configuration/devisConf';

export default function genererCritereRecherche() {
  return {
    codes: [],
    etat: [],
    produitsIds: [],
    tiersId: [],
    societeId: null,
    module: MODULE_ACHAT,
    sousType: [SOUS_TYPE_NORMAL],
  };
}
